export default __webpack_public_path__ + "static/media/pages.38acb39c.svg";